import { safeWindow } from 'src/utils/static-generation';

export const isSystemDarkMode = () => {
  return (
    safeWindow?.matchMedia?.('(prefers-color-scheme: dark)').matches ||
    safeWindow?.navigator.userAgent.includes('ColorScheme/dark')
  );
};
